import React from 'react';
import { Icon } from '@groupby/ui-components';
export const RefreshIcon = ({ width = 24, height = 24 }) => (<Icon variant="refresh" color="currentColor" width={width} height={height}/>);
export default RefreshIcon;
